import { createSelector } from 'reselect';
import { get } from 'lodash';
import { useSelector } from 'react-redux';

import { getCurrentLeg } from './screen';
import { documentsSort } from '../service/sort';

export const getDocumentsNotifications = createSelector(
    (state) => get(state, 'documents'),
    (documents) => {
        const documentList = [];
        Object.keys(documents || {}).forEach((key) => {
            const document = documents[key];
            if (!document.isDownloaded) {
                documentList.push(document);
            }
        });

        return documentList;
    }
);

export const getDocuments = createSelector(
    getCurrentLeg,
    (state) => get(state, 'documents', {}),
    (leg = {}, documents) => {
        return get(leg, 'documentIds', []).map((documentId) => documents[documentId]);
    }
);

export const useDocuments = () => useSelector(getDocuments);

export const getCurrentDocuments = createSelector(getCurrentLeg, getDocuments, (leg = {}, documents) => {
    if (!documents || !documents.length || !leg) {
        return { count: 0, documents: {} };
    }

    const airportTakeOff = leg.airportTakeOff ?? {};
    const airportLanding = leg.airportLanding ?? {};

    const route = {};
    route[airportTakeOff.code] = {
        airportEng: airportTakeOff.nameEng ?? airportTakeOff.name,
    };

    route[airportLanding.code] = {
        airportEng: airportLanding.nameEng ?? airportLanding.name,
    };

    return Object.entries(route).reduce(
        (res, [key, { airportEng }]) => {
            const airportDocs = documents.filter(({ airport }) => airport === airportEng);

            if (airportDocs.length > 0) {
                res.documents[key] = airportDocs.sort(documentsSort);
                res.count += airportDocs.length;
            }

            return res;
        },
        { count: 0, documents: {} }
    );
});

export const useHasDocuments = () =>
    useSelector(() => {
        const documents = useDocuments();

        return documents.length > 0;
    });

export const useDocumentCounts = () =>
    useSelector(() => {
        const documents = useDocuments();

        return {
            count: documents.length,
            notDownloaded: documents.filter(({ isDownloaded }) => !isDownloaded).length,
        };
    });

export const useLegDocumentNotifications = () =>
    useSelector(() => {
        const documents = useDocuments();

        return documents.filter(({ isDownloaded }) => !isDownloaded);
    });
